var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chevron-down",
    d: "M8.11953 14.7099L11.9995 10.8299L15.8795 14.7099C16.2695 15.0999 16.8995 15.0999 17.2895 14.7099C17.6795 14.3199 17.6795 13.6899 17.2895 13.2999L12.6995 8.70994C12.3095 8.31994 11.6795 8.31994 11.2895 8.70994L6.69953 13.2999C6.30953 13.6899 6.30953 14.3199 6.69953 14.7099C7.08953 15.0899 7.72953 15.0999 8.11953 14.7099Z",
    fill: "#0A7AFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueChevronUp);
export default __webpack_public_path__ + "static/media/blue-chevron-up.8b6ee6b911e525addfc78886f8855510.svg";
export { ForwardRef as ReactComponent };